var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from './card.styles';
import { classNames } from '../../utils/style-class.utils';
export var Card = function (_a) {
    var _b = _a.borderRaduis, borderRaduis = _b === void 0 ? 'sm' : _b, _c = _a.shadowSize, shadowSize = _c === void 0 ? 'sm' : _c, className = _a.className, children = _a.children;
    return (_jsx("div", __assign({ className: classNames(styles.getCardStyles(borderRaduis, shadowSize), className) }, { children: children })));
};
//# sourceMappingURL=card.js.map